import * as XLSX from 'xlsx';

export const todaycode = transformDateToCode((new Date()).toISOString());
const PORT_BACK: string = import.meta.env.VITE_PORT_BACK;
const PORT_AUTH: string = import.meta.env.VITE_PORT_AUTH;
export const app_name: string = import.meta.env.VITE_APP_NAME;
const env = import.meta.env.VITE_ENV;

export const backend_url =
  env === 'dev'
    ? `http://localhost:${PORT_BACK}`
    : 'https://api-rncp37827.elpulpo.xyz';

export const auth_url =
  env === 'dev'
    ? `http://localhost:${PORT_AUTH}`
    : 'https://auth-rncp37827.elpulpo.xyz';

// Méthode pour déterminer le style de la cellule selon la valeur (de 1 à 5)
export function getCellStyle(value: any) {
  if (value == null || value === '') {
    return {};
  }
  const color = getColorForValue(value);
  const style: any = {
    backgroundColor: color,
  };

  style.color = 'white';

  return style;
}

// Fonction pour déterminer la couleur basée sur la valeur
export function getColorForValue(value: any) {
  const min = 0;
  const max = 5;
  const ratio = (value - min) / (max - min);
  const alpha = value === 0 ? 0 : Math.min(1, ratio);
  const blue = Math.floor(230 * (1 - ratio)); // Le bleu commence à 230 et diminue jusqu'à 0.
  const red = 0;
  const green = 0;

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`; // Utilisation de 'rgba' pour ajouter la transparence
}

export function transformDateToCode(dateStr: string): string {
  // Crée un objet Date à partir de la chaîne
  const date = new Date(dateStr);

  // Vérifie si la date est valide
  if (isNaN(date.getTime())) {
    return "Date invalide"; // Retourne un message si la date est invalide
  }

  // Récupère l'année (sur les 2 derniers chiffres)
  const year: string = date.getFullYear().toString().slice(-2);

  // Récupère le jour de l'année (1-365)
  const start: Date = new Date(date.getFullYear(), 0, 0); // Le début de l'année
  const diff: number = date.getTime() - start.getTime(); // Différence en millisecondes

  const oneDay: number = 1000 * 60 * 60 * 24; // Nombre de millisecondes dans une journée
  const dayOfYear: number = Math.floor(diff / oneDay); // Calcul du jour de l'année

  // Formate le jour de l'année avec 3 chiffres
  const dayOfYearFormatted: string = dayOfYear.toString().padStart(3, '0');

  // Retourne le code dans le format souhaité
  return `${year}-${dayOfYearFormatted}`;
}

export function getWeekNumber(date: Date): number {
  const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = tempDate.getUTCDay() || 7; // dim=0 => 7
  tempDate.setUTCDate(tempDate.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
  return Math.ceil((((tempDate.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
}


export function transformCodeToDate(code: string): string {
  const regex = /^(\d{2})-(\d{3})$/;
  const match = code.match(regex);

  if (!match) {
    return "Code invalide";
  }

  const year = 2000 + parseInt(match[1], 10);
  const dayOfYear = parseInt(match[2], 10);

  if (isNaN(dayOfYear) || dayOfYear < 1 || dayOfYear > 366) {
    return "Code invalide";
  }

  // Crée une date locale au 1er janvier
  const date = new Date(year, 0, dayOfYear);

  // Retourne une date au format YYYY-MM-DD en local (pour éviter décalages)
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}`;
}

export function formatDateToFrench(dateStr: string): string {
  const [year, month, day] = dateStr.split('-');
  const shortYear = year.slice(-2);
  return `${day}/${month}/${shortYear}`;
}

export function roundFloat(numberToRound: number) {
  return numberToRound.toFixed(2)
}

export function calculateAgeInDays(pDayCode: string, selectedStartDayCode: string): number {
  const pDateStr = transformCodeToDate(pDayCode);
  const startDateStr = transformCodeToDate(selectedStartDayCode);

  if (pDateStr === "Code invalide") {
    console.error(`Le code PDate est invalide : "${pDayCode}"`);
    return -1;
  }

  if (startDateStr === "Code invalide") {
    console.error(`Le code StartDate est invalide : "${selectedStartDayCode}"`);
    return -1;
  }

  const pDate = new Date(pDateStr);
  const startDate = new Date(startDateStr);

  const diffDays = Math.floor((pDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));

  return diffDays;
}

export function getMonthFromDaycode(daycode: string): number {
  const match = daycode.match(/^(\d{2})-(\d{3})$/);
  if (!match) return 0;
  const year = parseInt('20' + match[1], 10);
  const dayOfYear = parseInt(match[2], 10);
  const date = new Date(year, 0); // 1er janvier
  date.setDate(dayOfYear);
  return date.getMonth() + 1; // Janvier = 1
}

export const exportToExcel = (data: any[], filename: string) => {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, filename);
};

export function getZoneLabel(zone: 'zoneA' | 'zoneB' | 'zoneC'): string {
  switch (zone) {
    case 'zoneA':
      return 'Zone A';
    case 'zoneB':
      return 'Zone B';
    case 'zoneC':
      return 'Zone C';
    default:
      return zone;
  }
}

// Mapping des IDs de reactorsState vers dataStore.pbrs
export const idMapping: Record<number, number> = {
  1: 1,   // R01 → R1
  2: 2,   // R02 → R2
  3: 3,   // R03 → R3
  4: 4,   // R04 → R4
  5: 5,   // R05 → R5
  6: 6,   // R06 → R6
  7: 7,   // R07 → R7
  8: 8,   // R08 → R8
  9: 9,   // R09 → R9
  10: 10, // R10 → R10
  11: 11, // R11 → R11
  12: 12, // R12 → R12
  13: 13, // R13 → R13
  14: 14, // R14 → R14
  15: 15, // R15 → R15
  16: 16, // R16 → R16
  17: 17, // R17 → R17
  18: 18, // R18 → R18
  19: 19, // R19 → R19
  20: 20, // R20 → R20
  23: 21, // R21 → R21
  26: 22, // R22 → R22
  27: 23, // R23 → R23
  28: 24, // R24 → R24
  29: 25, // R25 → R25
  30: 26, // R26 → R26
  24: 27, // R27 → R27
  31: 28, // R28 → R28
  32: 29, // R29 → R29
  33: 30, // R30 → R30
  25: 31, // R31 → R31
  21: 32, // R32 → R32
  22: 33, // R33 → R33
  34: 34, // R34 → R34
  35: 35, // R35 → R35
  36: 36, // R36 → R36
  37: 37, // R37 → R37
  38: 38, // R38 → R38
  39: 39, // R39 → R39
  40: 40, // R40 → R40
  41: 41, // R41 → R41
  42: 42, // R42 → R42
  43: 43  // R43 → R43
};